module.exports = __webpack_public_path__ + "img/triangle-60.784bd4ef.gif";